import { React, useEffect, useState, useRef } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import { Button, PageHeader, Table, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { Styled } from "../../pageStyled";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getCustomersForConfiguration,
  searchCustomers,
  getFilteredCustomers,
} from "../../../Services/customerServices";
import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import EmptyState from "../../../Components/EmptyState/emptyState";

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const CustomerRecordsData = (props) => {
  const [customerRecords, setCustomerRecords] = useState([]);
  const [exportRecords, setExportRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [tableParams, setTableParams] = useState({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const location = useLocation();
  const history = useNavigate();
  const [addToaster, setAddToaster] = useState(
    location.state?.action === "add"
  );
  const [deleteToaster, setDeleteToaster] = useState(
    location.state?.action === "delete"
  );
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [rendering, setRendering] = useState(false);
  const titleRef = useRef(null);
  const searchRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, table: 100 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        table: baseTop + titleHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, [rendering]);

  const paginationRef = useRef({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10,
  });
  const columnsHead = useRef([
    {
      title: "CUSTOMER CODE",
      dataIndex: "code",
      width: "17%",
      sorter: {
        compare: (a, b) => a.code - b.code,
      },
      align: "left",
    },
    {
      title: "CREATED DATE",
      dataIndex: "created_at",
      width: "13%",
      sorter: {
        compare: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      },
    },
    {
      title: "CUSTOMER NAME",
      dataIndex: "name",
      width: "18%",
      sorter: {
        compare: (a, b) => a.name && b.name && a.name.localeCompare(b.name),
      },
    },
    {
      title: "COUNTRY",
      dataIndex: "country",
      width: "16%",
      sorter: {
        compare: (a, b) => a.country && b.country && a.country.localeCompare(b.country),
      },
    },
    {
      title: "CITY & AREA",
      dataIndex: "city",
      width: "14%",
    },
    {
      title: "TYPE",
      dataIndex: "type",
      width: "16%",
    },
    {
      title: "Category",
      dataIndex: "category",
      width: "16%",
    },
    {
      title: "STATUS",
      dataIndex: "status",
      width: "18%",
      render: (text, record) => (
        <div className="statusVal" dataval={text}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                text === "Active"
                  ? "This customer is active."
                  : text === "Deactive" || text === "Disabled"
                    ? "This customer is disabled. You cannot accept orders for this customer."
                    : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {text}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      render: (text, record) => (
        <div className="actionBtn">
          {userDetails.roles.customer_records.edit && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit this Customer"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => handleEdit(record.code)}>
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View this Customer"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleView(record.code)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ]);

  const routeChange = () => {
    history("./add-new-customer", {
      state: { action: "add" },
    });
  };

  const handleEdit = (code) => {
    history("./edit-customer", {
      state: { action: "edit", customercode: code },
    });
  };

  const handleView = (code) => {
    history("./view-customer", {
      state: {
        action: "view",
        customercode: code,
        roles: userDetails.roles.customer_records,
      },
    });
  };

  const exportHandler = () => {
    const currentDate = new Date();
    const today = (currentDate.getDate() + "/" + currentDate.toLocaleString("default", { month: "long" }) + "/" + currentDate.getFullYear());
    let fileName = "Customer_Records_Kiaznn_" + today;
    if (appliedFilters.length) {
      history("../customer-records/export-customer", {
        state: {
          body: {
            appliedFilters: appliedFilters,
            page: "customer records",
            type: "Filter",
            searchValue: searchValue
          },
          rootPage: "../customer-records",
          fileName: fileName,
        },
      });
    } else if (!clearSearch && searchValue) {
      let params = {
        sort_by: "created_at",
        sort_type: "descending",
      }
      history("../customer-records/export-customer", {
        state: {
          body: {
            searchValue: searchValue,
            params: params,
            page: "customer records",
            type: "Search"
          },
          rootPage: "../customer-records",
          fileName: fileName,
        },
      });
    } else {
      history("../customer-records/export-customer", {
        state: {
          body: {
            page: "customer records",
            type: "All Data"
          },
          rootPage: "../customer-records",
          fileName: fileName,
        },
      });
    }
  };

  const tableData =
    customerRecords &&
    customerRecords?.map((customer, index) => {
      return {
        key: `${index}`,
        code: customer.code,
        created_at: moment(customer.created_at).format("DD MMM YYYY"),
        name: customer.name,
        country: customer.country,
        city: customer.city,
        type: `${customer.type == "dealer"
            ? "Dealer"
            : customer.type == "direct_customer"
              ? "Direct Customer"
              : null
          }`,
        status: capitalize(customer.status),
        category: customer.category == "domestic"
          ? "Domestic"
          : customer.category == "export"
            ? "Export"
            : '-',
      };
    });

  const searchCust = async (value = "") => {
    setCustomerRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    setLoading(true);
    setSearchValue(value);
    // if (value === "" || value === null) {
    //   setAppliedFilters([]);
    //   setFilterTags([]);
    //   fetchCustomers(paginationRef.current);
    // } else {
    //   setClearSearch(false);
    //   searchCustomers(value, paginationRef.current)
    //     .then((response) => {
    //       setLoading(false);
    //       setEmptyStateLabel("search");
    //       setCustomerRecords(response.customers);
    //       setTotalRecords(response.total_customers);

    //     })
    //     .catch((error) =>
    //       console.log("Error in searching customers:", error),
    //       setEmptyStateLabel("connectionAPIError")
    //     );
    // }
  };

  const refresh = () => {
    setLoading(true);
    setCustomerRecords();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  }

  useEffect(() => {
    if (rendering && !appliedFilters.length && searchValue == "") {
      setLoading(true);
      fetchCustomers(paginationRef.current);
      setRendering(false);
    }
    else if (!appliedFilters.length && searchValue == "") {
      fetchCustomers(paginationRef.current);
      //return () => setCustomerRecords([]);
    }
  }, [tableParams, rendering]);

  useEffect(() => {
    if ((appliedFilters.length && searchValue !== "") || appliedFilters.length) {
      setLoading(true);
      fetchFilteredCustomers();
    } else if (!appliedFilters.length && searchValue !== "") {
      setLoading(true);
      searchCustomers(searchValue, paginationRef.current)
        .then((response) => {
          setLoading(false);
          setEmptyStateLabel("search");
          setCustomerRecords(response.customers);
          setTotalRecords(response.total_customers);

        })
        .catch((error) =>
          console.log("Error in searching customers:", error),
          setEmptyStateLabel("connectionAPIError")
        );
    } else {
      fetchCustomers(paginationRef.current);
    }
  }, [appliedFilters, tableParams, searchValue]);

  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  const fetchCustomers = (params) => {
    getCustomersForConfiguration(params)
      .then((response) => {
        setLoading(false);
        if (!response.customers.length) {
          setEmptyStateLabel("noData");
        }
        setCustomerRecords(response.customers);
        setTotalRecords(response.total_customers);
        setLoading(false);
        // console.log("cust", customerRecords);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        setEmptyStateLabel("connectionAPIError");
      });
  };

  const fetchFilteredCustomers = (params) => {
    setLoading(true); // usually you start loading before API call
    getFilteredCustomers(paginationRef.current, appliedFilters, undefined, searchValue)
      .then((response) => {
        setLoading(false);
        setEmptyStateLabel("filter");
        setCustomerRecords(response.data.customers);
        setTotalRecords(response.data.total_customers);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  function onChange(pagination, filters, sorter, extra) {
    setCustomerRecords([]);
    setLoading(true);
    columnsHead.current?.map((item) => {
      if (item.dataIndex !== sorter?.field) {
        item["sortOrder"] = null;
      }
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });

    const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
    if (
      sorter.field &&
      (paginationRef.current.sort_type !== tempSort)
    ) {
      setClearSearch(true);
      setCurrentPage(1);
      setTableParams({
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      };
    } else {
      setClearSearch(true);
      setCurrentPage(pagination.current);
      setTableParams({
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      };
    }
  }

  const applyfilter = (filter) => {
    setCustomerRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    setCurrentPage(1);

    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
    setTableParams((prevState) => ({
      ...prevState,
      page: 1,
      size: 10,

    }));
    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "country":
        const value =
          item.country.length > 1
            ? `${item.country[0]} or ${item.country.length - 1} others`
            : `${item.country[0]}`;
        // const concatString = item.country.join(" or ");
        // const countryToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Country",
          operand: "equals",
          value,
          // tooltip: countryToolTip,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        //const dateTip = `Created date ${dateOperand} ${dateValue} `
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "status":
        const formattedStatus =
          item.status === "both"
            ? `Active/Disabled`
            : item.status === "active"
              ? `Active`
              : `Disabled`;
        // const statusTip = `Status - ${formattedStatus}`;
        return {
          type: item.type,
          formattedType: "Status",
          operand: "-",
          value: formattedStatus,
          // tooltip: statusTip,
        };
      case "category":
        const formattedCategory =
          item.category === "both"
            ? `Domestic/Export`
            : item.category === "domestic"
              ? `Domestic`
              : `Export`;
        // const statusTip = `Status - ${formattedStatus}`;
        return {
          type: item.type,
          formattedType: "Category",
          operand: "-",
          value: formattedCategory,
          // tooltip: statusTip,
        };
    }
  };

  const removeFilter = (filter) => {
    setCustomerRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    // setSearchValue("");
    // setClearSearch(true);
    setLoading(true);
    setRendering(true);
    setCurrentPage(1);
    setTableParams((prevState) => ({
      ...prevState,
      page: 1,
      size: 10,

    }));
    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }

  };
  const onUploadCustomer = () => {
    history("./upload-customers");
  }
  return (
    <RightLayoutContainer id="right-layout-container">
      <style dangerouslySetInnerHTML={{
        __html: `
        .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
          overflow: visible !important;
        }
        .ant-table-sticky-holder {
          z-index: 101 !important;
        }
        .tableDataFormat table colgroup col:nth-child(7),
        .tableDataFormat table thead th.ant-table-cell:nth-child(7) {
          min-width: 120px !important;
          width: 120px !important;
        }
      `}} />
      <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff", paddingBottom: "10px" }}>
        <PageHeader
          ghost={false}
          title="Customer Records"
          extra={
            userDetails.roles.customer_records.edit && [
              <Button
                key="1"
                className="themeBtn noBg"
                // disabled={!roles.edit_own}
                onClick={onUploadCustomer}
              >
                <Iconmoon icon="import" size={14} color="#EA655B" />
                Upload Customers
              </Button>,
              <Button key="2" className="themeBtn" onClick={routeChange}>
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Add a new customer
              </Button>,
            ]
          }
        ></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <div ref={searchRef} style={{ backgroundColor: "#fff" }}>
            <SearchContainer
              placeholder={"Search customer code or customer name"}
              fetchOrder={searchCust}
              exportRole={tableData?.length ? true : false}
              exportTrigger={exportHandler}
              clearSearch={clearSearch}
              setClearSearch={setClearSearch}
              searchedValue={searchValue}
              filterOptions={[
                {
                  key: 0,
                  label: "Filter by Created date",
                  value: "created_date",
                  type: "date",
                },
                {
                  key: 1,
                  label: "Filter by Country",
                  value: "country",
                  type: "multiSelect",
                },
                {
                  key: 2,
                  label: "Filter by Category",
                  value: "category",
                  type: "multiSelect",
                },
                {
                  key: 3,
                  label: "Filter by Status",
                  value: "status",
                  type: "multiSelect",
                },
              ]}
              applyFilter={applyfilter}
            />
            {filterTags.map((filter) => (
              // <Tooltip
              //   placement="bottomRight"
              //   title={filter.tooltip || ""}
              //   className="edit-tooltip"
              //   getPopupContainer={(triggerNode) => triggerNode}
              // >
              <span className="filter-tags">
                <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                &nbsp;
                <span>{filter.formattedType}</span>
                &nbsp;
                <span>{filter.operand}</span>
                &nbsp;
                <span>{filter.value}</span>
                <span>
                  {" "}
                  <button
                    onClick={() => {
                      removeFilter(filter);
                    }}
                  >
                    {" "}
                    <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                  </button>
                </span>
                <Styled></Styled>
              </span>
              // {/* </Tooltip> */}
            ))}
          </div>
          {loading ? (
            <TableShimmer
              header={columnsHead.current}
              scroll={{ x: 1000 }}
            />
          ) : tableData?.length ? (
            <Table
              columns={columnsHead.current}
              dataSource={tableData}
              // dataSource={dataBody}
              onChange={onChange}
              pagination={{
                current: currentPage,
                total: totalRecords,
                showTitle: false,
                showSizeChanger: true,
                pageSize: paginationRef.current.size,
                showTotal: (total, range) =>
                  `Showing ${range[0]}-${range[1]} of ${total} results`,
              }}
              scroll={{ x: "max-content" }}
              sticky={{
                offsetHeader: stickyOffsets.table,
                getContainer: () => {
                  let node = document.getElementById('right-layout-container');
                  while (node && node !== document.body) {
                    const style = window.getComputedStyle(node);
                    if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                    node = node.parentNode;
                  }
                  return window;
                }
              }}
            />
          ) : (
            <EmptyState
              img={emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData :
                emptyStateLabel === "search" ? emptyState_Search :
                  emptyState_ConnectionAPIError}
              heading={emptyStatePropsData.heading}
              subHeading={emptyStatePropsData.subHeading}
              label={emptyStatePropsData.label}
              refresh={refresh}
            />
          )}
        </div>
      </TableLayoutData>

      {addToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setAddToaster}
          color={`${location.state.response.error ? "red" : "green"} toaster`}
          icon={location.state.response.error ? alertRed : alertGreen}
          msg={
            location.state.response.error
              ? location.state.response.msg
              : `A new customer ${location.state.response.data.alias} is successfully added`
          }
        >
          {setTimeout(() => setAddToaster(false), 3000)}
        </AlertContainer>
      )}

      {deleteToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setDeleteToaster}
          color={`${location.state.response.error ? "red" : "green"} toaster`}
          icon={location.state.response.error ? alertRed : alertGreen}
          msg={
            location.state.response.error
              ? location.state.response.msg
              : `Customer is successfully deleted`
          }
        >
          {setTimeout(() => setDeleteToaster(false), 3000)}
        </AlertContainer>
      )}
    </RightLayoutContainer>
  );
};

export default CustomerRecordsData;
